module.exports = "<chassis-datatable-2\n    [columns]=\"columns\"\n    [data]=\"data\"\n    [take]=\"take\"\n    [hidden]=\"hidden\"\n    [process]=\"false\"\n    [actions]=\"['edit', 'show', 'delete']\"\n    (changed)=\"onChange($event)\"\n></chassis-datatable-2>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-nova/src/components/datatable/datatable.component.html
// module id = ./libs/chassis-nova/src/components/datatable/datatable.component.html
// module chunks = main